import { Toro } from '../common/enumerations';
import { ConnectedDevice } from './connected-device.model';
import { Organization } from './organization.model';
import { ToroAccountSimple } from './toro-account-simple.model';
import { ToroLocation } from './toro-location.model';

export class ToroAccountDetailed extends ToroAccountSimple
{
    private _organization: Organization;
    private _locations: ToroLocation[] = [];
    private _connectedDevices: ConnectedDevice[] = [];

    constructor(json: object = null,
                accountType: Toro.AccountType = Toro.AccountType.Administered)
    {
        super(accountType, json, true);

        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);
        }

        this.AccountType = accountType;
    }

    public get Organization(): Organization
    {
        return this._organization;
    }

    public set Organization(value: Organization)
    {
        this._organization = new Organization(value);
    }

    public get Locations(): ToroLocation[]
    {
        return this._locations;
    }

    public set Locations(value: ToroLocation[])
    {
        this._locations.length = 0;

        value.forEach(location =>
        {
            this._locations.push(new ToroLocation(location));
        });
    }

    public get ConnectedDevices()
    {
        return this._connectedDevices;
    }

    public set ConnectedDevices(connectedDevices: ConnectedDevice[])
    {
        this._connectedDevices = connectedDevices;
    }

}
